export default __webpack_public_path__ + "5a47d66ff4f633e3962ca1523f009a81.png";